import { RouteIcon } from './icons';

export interface JobHeaderLogoProps {
  /** URL da logo da empresa (do `Program.company.logoUrl`). Quando ausente,
   *  renderiza um placeholder com `RouteIcon`. */
  logoUrl?: string | null;
  /** Nome da empresa — usado como `<img alt>`. */
  companyName?: string | null;
}

/**
 * Avatar 32×32 do header das telas de edição de vaga (hub + 8 subseções).
 * Renderiza a logo da empresa via `<img>` quando disponível; senão cai no
 * placeholder com `RouteIcon`. Reusado para evitar duplicação visual.
 */
export function JobHeaderLogo({ logoUrl, companyName }: JobHeaderLogoProps) {
  if (logoUrl) {
    return (
      <img
        src={logoUrl}
        alt={companyName ? `Logo de ${companyName}` : 'Logo da empresa'}
        className="size-8 rounded-md object-cover"
      />
    );
  }
  return (
    <div className="flex size-8 items-center justify-center rounded-md bg-secondary text-secondary-foreground">
      <RouteIcon className="size-4" />
    </div>
  );
}
